export default __webpack_public_path__ + "text.asset.c0e24304c0b5988dcdcbd8d1d8137f7d.svg";